import Vue from 'vue'
import App from './App.vue'
import PageActionBar from './components/PageActionBar.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import './plugins'
import store from './store'
import { sync } from 'vuex-router-sync'
import rowLongPress from './directives/rowLongPress'
import { syncPushToken } from './services/pushNotificationService'
import { USER_KEY } from './util/globals'

// Remove credentials left by versions that persisted the entire user session.
localStorage.removeItem(USER_KEY)

Vue.config.productionTip = false
Vue.component('PageActionBar', PageActionBar)
Vue.directive('row-long-press', rowLongPress)

sync(store, router)

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App),
}).$mount('#app')

if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      await navigator.serviceWorker.register(`${process.env.BASE_URL}service-worker.js`)
      const user = store.get('authStore@currentUser')
      if (user) {
        await syncPushToken({ receiveNotifications: Boolean(user.receiveNotifications) })
      }
    } catch (error) {
      console.error('Service worker registration failed:', error)
    }
  })
}
